const StateConstants = {
  ARCHIVED: 'ARCHIVED',
  DEFAULT: 'ALL',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
};
export default StateConstants;
export const STATES = [StateConstants.DEFAULT, StateConstants.DRAFT, StateConstants.PUBLISHED, StateConstants.ARCHIVED];
export const STATES_PATHS = [StateConstants.DEFAULT.toLowerCase(), StateConstants.DRAFT.toLowerCase(), StateConstants.PUBLISHED.toLowerCase(), StateConstants.ARCHIVED.toLowerCase()];
export const CATEGORY_STATES = [StateConstants.DEFAULT, StateConstants.PUBLISHED, StateConstants.DRAFT];